import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

const customTwMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": [
				"text-heading-1",
				"text-heading-2",
				"text-heading-3",
				"text-heading-4",
				"text-heading-5",
				"text-sub-heading",
				"text-paragraph-1",
				"text-paragraph-2",
				"text-paragraph-3",
				"text-caption",
				"text-extra-small",
			],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return customTwMerge(clsx(inputs));
}
